import { getPostLogoutUrl } from './postLogoutUrl';

export function getPostLogoutTarget() {
  const redirectUrl = getPostLogoutUrl();
  if (redirectUrl) {
    return { type: 'external', url: redirectUrl };
  }
  return { type: 'login', url: '/login' };
}

export function applyPostLogoutRedirect(navigate) {
  const target = getPostLogoutTarget();
  if (target.type === 'external') {
    window.location.assign(target.url);
    return;
  }
  navigate(target.url, { replace: true });
}
